import { HelpCircle, Laptop, Smartphone, Tablet } from 'lucide-react';

import { DeviceSession, DeviceType } from '@/types';

export const deviceTypeIcon = (deviceType: DeviceType) => {
  switch (deviceType) {
    case 'mobile':
      return Smartphone;
    case 'tablet':
      return Tablet;
    case 'desktop':
      return Laptop;
    default:
      return HelpCircle;
  }
};

export const deviceTypeLabel = (deviceType: DeviceType): string => {
  switch (deviceType) {
    case 'mobile':
      return 'Phone';
    case 'tablet':
      return 'Tablet';
    case 'desktop':
      return 'Computer';
    default:
      return 'Unknown device';
  }
};

export const formatBrowser = (
  session: Pick<DeviceSession, 'browser' | 'browserVersion'>,
): string => {
  if (!session.browser) {
    return 'Unknown browser';
  }
  const majorVersion = session.browserVersion?.split('.')[0];
  return majorVersion ? `${session.browser} ${majorVersion}` : session.browser;
};

export const formatLocation = (
  session: Pick<DeviceSession, 'geoCity' | 'geoRegion' | 'geoCountry'>,
): string => {
  const parts = [session.geoCity, session.geoRegion, session.geoCountry].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : 'Unknown location (local network)';
};
